module.exports = __webpack_public_path__ + "img/product-colourboard.8fba369b.png";